import { useTranslate } from 'hooks/useTranslate';

import { Document } from 'types';
import { getDocumentIcon } from 'utils/documentIcons';
import { getFileDate } from 'utils/files';

type Props = {
  index: number;
  document: Document | File;
};

const DocumentsRow = ({ index, document }: Props) => {
  const itsRawFile: boolean =
    (document as Document)?._id === undefined ||
    (document as Document)?._id === null;

  const { t } = useTranslate();

  return (
    <div
      className="nk-file-item nk-file documents-section-row"
      key={`document-${index}`}
    >
      <div className="nk-file-info">
        <div className="nk-file-title w-100">
          <div className="nk-file-icon">
            <span className="nk-file-icon-type">
              <img
                src={getDocumentIcon(document, itsRawFile)}
                alt="icon-file"
              />
            </span>
          </div>

          <div className="nk-file-name">
            <div
              className="nk-file-name-text d-flex flex-column"
              style={{ maxWidth: '300px' }}
            >
              <span className="title text-ellipsis" title={document?.name}>
                {document?.name}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="nk-file-meta d-none d-xl-table-cell">
        <div className="tb-lead text-center">{getFileDate(document)}</div>
      </div>
    </div>
  );
};

export default DocumentsRow;
